// encode(decode) html text into html entity

export function decodeHtmlEntity(str: string) {
	str = str.replace(/&nbsp;/g, '');
	return str.replace(/&#(\d+);/g, function (match, dec) {
		return String.fromCharCode(dec);
	});
}
